import { render, staticRenderFns } from "./glossary.vue?vue&type=template&id=1fe2b154&"
import script from "./glossary.vue?vue&type=script&lang=js&"
export * from "./glossary.vue?vue&type=script&lang=js&"
import style0 from "./glossary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports